/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  DeactivateUserOptions,
  DeactivateUserStatus202,
  DeactivateUserStatus400,
  DeactivateUserStatus404,
  DeactivateUserStatus409,
  DeactivateUserStatus500,
} from '../types/DeactivateUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { deactivateUser } from '../clients/deactivateUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const deactivateUserMutationKey = () => [{ url: '/v1/user/:user_id/deactivate' }] as const

export function deactivateUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = deactivateUserMutationKey()
  return mutationOptions<
    DeactivateUserStatus202,
    ResponseErrorConfig<
      | DeactivateUserStatus400
      | DeactivateUserStatus404
      | DeactivateUserStatus409
      | DeactivateUserStatus500
    >,
    DeactivateUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return deactivateUser({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Creates an asynchronous deactivation request, or re-triggers a FAILED one. Trading, funding, and transfers are blocked immediately; a background daemon cancels open orders, closes positions at market price, repays outstanding debt and interest, and sweeps remaining cash into the user's global account. The request is only marked COMPLETED once every step succeeds. Poll GET /v1/user/{user_id}/deactivation for the outcome.
 * @summary Deactivate a user's account (admin)
 * {@link /v1/user/:user_id/deactivate}
 */
export function useDeactivateUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeactivateUserStatus202,
      ResponseErrorConfig<
        | DeactivateUserStatus400
        | DeactivateUserStatus404
        | DeactivateUserStatus409
        | DeactivateUserStatus500
      >,
      DeactivateUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deactivateUserMutationKey()

  const baseOptions = deactivateUserMutationOptions(config) as UseMutationOptions<
    DeactivateUserStatus202,
    ResponseErrorConfig<
      | DeactivateUserStatus400
      | DeactivateUserStatus404
      | DeactivateUserStatus409
      | DeactivateUserStatus500
    >,
    DeactivateUserOptions,
    TContext
  >

  return useMutation<
    DeactivateUserStatus202,
    ResponseErrorConfig<
      | DeactivateUserStatus400
      | DeactivateUserStatus404
      | DeactivateUserStatus409
      | DeactivateUserStatus500
    >,
    DeactivateUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeactivateUserStatus202,
    ResponseErrorConfig<
      | DeactivateUserStatus400
      | DeactivateUserStatus404
      | DeactivateUserStatus409
      | DeactivateUserStatus500
    >,
    DeactivateUserOptions,
    TContext
  >
}
